import { clsx } from 'clsx';
import { RectangleSkeleton, TextSkeleton, Utils, Divider } from '@treezor/design-system';

export const PaymentCardsSkeleton = () => (
  <div className="flex flex-col w-[25rem] h-full p-6 rounded-200 border border-primary box-border bg-secondary">
    <TextSkeleton width="40%" margin="16px 0" />
    <RectangleSkeleton width="100%" height="14rem" margin="0" />
    <div className="flex gap-3 mx-auto my-5">
      {Utils.createEmpty(5).map((_, index) => (
        <span
          key={index}
          className={clsx(
            'rounded-full w-7 h-7 line- text-center leading-8',
            index === 1 ? 'text-onColor bg-disabled' : 'text-disabled bg-none',
          )}
        >
          {index + 1}
        </span>
      ))}
    </div>
    <Divider />
    <div className="flex justify-end mt-3">
      <TextSkeleton width="40%" />
    </div>
  </div>
);
